import { render, staticRenderFns } from "./ImgScreen.vue?vue&type=template&id=202193a4&scoped=true"
import script from "./ImgScreen.vue?vue&type=script&lang=js"
export * from "./ImgScreen.vue?vue&type=script&lang=js"
import style0 from "./ImgScreen.vue?vue&type=style&index=0&id=202193a4&prod&lang=css"
import style1 from "./ImgScreen.vue?vue&type=style&index=1&id=202193a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202193a4",
  null
  
)

export default component.exports